import { render, staticRenderFns } from "./BatchDownloadSidePanel.vue?vue&type=template&id=67eef37f&scoped=true&"
import script from "./BatchDownloadSidePanel.vue?vue&type=script&lang=ts&"
export * from "./BatchDownloadSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eef37f",
  null
  
)

export default component.exports